import { Link } from 'react-router-dom';
import Panel from '~/components/Panel';
import { CampaignContactOption } from '~/types/fundrequests';

interface Props {
    csc: CampaignContactOption | null;
    campaignId?: number;
}

const CscBlock: React.FC<Props> = ({ csc, campaignId }) => {
    const bgColor = csc
        ? 'bg-[#e6f7f8] border-[#e6f7f8]'
        : 'bg-[#fdeaeb] border-[#fdeaeb]';

    return (
        <Panel addClasses={`${bgColor} flex-1`}>
            <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
                Client Services Coordinator
            </h2>
            <div
                className={`text-[38px]/[44px] ${
                    csc ? 'font-bold' : ''
                } text-[#131212] ${csc ? '' : 'italic'}`}
            >
                {csc ? `${csc.first_name} ${csc.last_name}` : 'None Assigned'}
            </div>
            <div className='text-[16px]/[24px]'>
                {!csc && (
                    <span className='text-[#999999]'>
                        Assigned at campaign level
                    </span>
                )}
                {csc && campaignId && (
                    <Link 
                        to={`/campaigns/${campaignId}`} 
                        className='text-[#00AEB3] hover:opacity-80'
                    >
                        View Campaign
                    </Link>
                )}
            </div>
        </Panel>
    );
};

export default CscBlock;